/** A file a conversation presented, as Orik stored a durable copy of it. */
export type Artifact = { url: string; filename: string; mimeType: string };

/**
 * A presented file's durable copy, from a delivery receipt's URL.
 *
 * Only Orik's own conversation-file route qualifies: a URL supplied anywhere else in a message is never offered
 * as a presented file's download.
 */
export function artifactFromFile(part: { data: string; mimeType: string; filename?: string }): Artifact | undefined {
  if (!/^\/api\/conversations\/[^/]+\/files\/[^/?]+(?:\?[^#]*)?$/.test(part.data)) return undefined;
  const url = new URL(part.data, "http://localhost");
  if (url.pathname !== part.data.split("?", 1)[0]) return undefined;
  return { url: part.data, filename: part.filename || url.searchParams.get("filename") || "Artifact", mimeType: part.mimeType };
}
